import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ProductHttpService } from 'src/app/http/product-http.service';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-product-new',
    templateUrl: './product-new.component.html',
    styles: [],
})
export class ProductNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private productHttpService: ProductHttpService,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public location: Location
    ) {}

    newProductForm = this.fb.group(
        {
            productName: [null, Validators.required],
            sectionId: [null, Validators.required],
            price: [null, Validators.required],
            desc: [null],
            assetId: [null],
            isPublished: [false],
            markAsNew: [false],
            hasOffer: [false, { updateOn: 'change' }],
            offerFrom: [null],
            offerTo: [null],
            offerType: ['DISCOUNT'],
            offerValue: [null],
            stock: [null],
            limitPerOrder: [null],
            limitPerDay: [null],
            specialDiscount: [null],
            index: [null],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    selectAsset: any;

    sections: any[] = [];

    offerType: any[] = [
        {
            name: 'Discount',
            id: 'DISCOUNT',
        },
        {
            name: 'Value',
            id: 'VALUE',
        },
    ];

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
        this.hasOfferValueChange();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.newProductForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.sections = data.data;
        });
    }

    onSubmit() {
        this.newProductForm.markAsTouched();
        if (this.newProductForm.valid) {
            this.productHttpService.newProduct(this.newProductForm.value).subscribe(
                () => {
                    this.router.navigateByUrl('product-list', {
                        state: { hasState: true, type: 'success', message: 'Product Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newProductForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.newProductForm.controls['assetId'].setValue(null);
    }

    hasOfferValueChange() {
        this.newProductForm.controls['hasOffer'].valueChanges.subscribe((data) => {
            if (data) {
                this.newProductForm.controls['offerFrom'].setValidators([Validators.required]);
                this.newProductForm.controls['offerTo'].setValidators([Validators.required]);
                this.newProductForm.controls['offerType'].setValidators([Validators.required]);
                this.newProductForm.controls['offerValue'].setValidators([Validators.required]);
                this.newProductForm.controls['stock'].setValidators([Validators.required]);
                this.newProductForm.controls['limitPerOrder'].setValidators([Validators.required]);
                this.newProductForm.controls['limitPerDay'].setValidators([Validators.required]);
            } else {
                this.newProductForm.controls['offerFrom'].clearValidators();
                this.newProductForm.controls['offerTo'].clearValidators();
                this.newProductForm.controls['offerType'].clearValidators();
                this.newProductForm.controls['offerValue'].clearValidators();
                this.newProductForm.controls['stock'].clearValidators();
                this.newProductForm.controls['limitPerOrder'].clearValidators();
                this.newProductForm.controls['limitPerDay'].clearValidators();
            }
            this.newProductForm.controls['offerFrom'].updateValueAndValidity();
            this.newProductForm.controls['offerTo'].updateValueAndValidity();
            this.newProductForm.controls['offerType'].updateValueAndValidity();
            this.newProductForm.controls['offerValue'].updateValueAndValidity();
            this.newProductForm.controls['stock'].updateValueAndValidity();
            this.newProductForm.controls['limitPerOrder'].updateValueAndValidity();
            this.newProductForm.controls['limitPerDay'].updateValueAndValidity();
        });
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
